"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AllocationConfigurationCatalogForm(_ref) {
  var catalogs = _ref.catalogs,
    onAdded = _ref.onAdded,
    onClose = _ref.onClose;
  var options = (0, _react.useMemo)(function () {
    return catalogs.map(function (catalog) {
      return {
        value: catalog.id,
        label: catalog.name
      };
    });
  }, [catalogs]);
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind;
  var onSubmit = function onSubmit() {
    if (!isValid()) return;
    onAdded(Object.assign(Object.assign({}, bind()), {
      editable: false
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('allocation_configurations.catalog'),
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.add'),
      onClick: onSubmit
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
    label: (0, _core.translate)('catalogs.single'),
    name: "catalog_id",
    options: options,
    required: true,
    register: register
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AllocationConfigurationCatalogForm);